<template>
  <v-form autocomplete="off">
    <v-row>
      <v-col cols="12" md="6">
        <gg-text-field
          autocomplete="off"
          v-model="name"
          label="Username"
          name="dbUser"
          :prefix="usernamePrefix"
          :counter="usernameMaxlength"
          v-validate="`required|max:${usernameMaxlength}`"
          :error-messages="errors.collect('dbUser')"
        />
      </v-col>
      <v-col cols="12" md="6">
        <compact-password
          cpanel-app="mysql"
          show-strength
          outlined
          label="Password"
          v-validate="'required'"
          data-vv-name="password"
          data-vv-as="Password"
          :error-messages="errors.collect('password')"
          with-generator
          v-model="password"
        />
      </v-col>
    </v-row>
    <gg-btn
      v-if="submitButton"
      :loading="loading"
      @click="createUser"
    >
      Create User
    </gg-btn>
  </v-form>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { randomName } from '@/helpers/helpers'
import CompactPassword from '@/components/Common/password/CompactPassword'

export default {
  name: 'CreateUserForm',
  components: {
    CompactPassword
  },
  props: {
    submitButton: {
      type: Boolean,
      default: true,
    },
  },
  data () {
    return {
      loading: false,
      name: '',
      password: '',
    }
  },
  computed: {
    ...mapGetters({
      mysqlRestrictions: 'mysql/mysqlRestrictions'
    }),
    usernamePrefix () {
      return this.mysqlRestrictions.prefix || ''
    },
    usernameMaxlength () {
      return this.mysqlRestrictions.max_username_length - this.usernamePrefix.length
    },
    username () {
      return this.usernamePrefix + this.name
    },
  },
  methods: {
    ...mapActions({
      createMysqlUser: 'mysql/createMysqlUser',
      getMysqlUsers: 'mysql/getMysqlUsers',
      reportSuccess: 'reportSuccess',
      reportError: 'reportError'
    }),
    generateName () {
      const length = 14
      this.name = randomName(length)
    },
    async createUser () {
      const valid = await this.$validator.validateAll()
      if (!valid) return
      this.loading = true
      this.$emit('loading-start')
      try {
        await this.createMysqlUser({ password: this.password, name: this.username, _username: this.$route.query.user })
        this.reportSuccess(`User "${this.username}" created.`)
        this.$emit('user-created', this.username)
        this.reset()
      } catch (e) {
        this.reportError(e)
      }
      this.loading = false
      this.$emit('loading-stop')
    },
    reset () {
      this.password = ''
      this.name = ''
      this.$nextTick(() => {
        this.$validator.reset()
      })
    }
  },
  created () {
    this.$on('create-user', () => {
      this.createUser()
    })
    this.generateName()
  },
  beforeDestroy () {
    this.$off('create-user')
  }
}
</script>
